<template>
  <div ref="sectionRef" class="w-full overflow-hidden">
    <Transition name="fade" class="delay-600">
      <Swiper
        v-if="data"
        :modules="modules"
        class="slider location-cards relative"
        :slides-per-view="1"
        :space-between="8"
        :speed="500"
        :center-insufficient-slides="true"
        :breakpoints="{
          1024: {
            slidesPerView: 'auto',
            allowTouchMove: false
          }
        }"
        @swiper="onSwiper"
      >
        <SwiperSlide v-for="(item, idx) in data" :key="idx" class="max-w-[1068px] cursor-none">
          <Image
            v-if="item"
            class="aspect-video object-cover"
            :src="item.responsiveImage ? item.responsiveImage?.src : item.url"
            :srcset="item.responsiveImage ? item.responsiveImage?.webpSrcSet : undefined"
            :width="item.responsiveImage ? item.responsiveImage?.width : (item.width ?? 20)"
            :height="item.responsiveImage ? item.responsiveImage?.height : (item.height ?? 20)"
            :alt="item?.alt ?? ''"
          />
          <span class="mt-2 inline-flex w-full gap-11 text-base text-black">
            <span class="flex-1 lg:flex-grow-0">
              {{ leadingZero(idx + 1) }}/{{ leadingZero(data.length) }}
            </span>
            <span v-if="item.title" class="flex-1 uppercase">
              {{ item.title }}
            </span>
          </span>
        </SwiperSlide>
        <SwiperCursors />
      </Swiper>
    </Transition>
  </div>
</template>

<script lang="ts" setup>
import { Parallax, A11y } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import type { FileField } from '~/types/datocms'

import 'swiper/css'

const modules = [Parallax, A11y]

defineProps({
  data: {
    type: Array as PropType<FileField[]>,
    default: () => []
  }
})

const swiperRef = ref<typeof Swiper | null>(null)

const onSwiper = (swiper: typeof Swiper) => {
  swiperRef.value = swiper
}

const leadingZero = (number: number) => {
  return number < 10 ? `0${number}` : `${number}`
}
</script>

<style lang="postcss">
.location-cards {
  @apply !overflow-visible px-4 lg:px-8;

  .swiper-wrapper {
    @apply box-border transform-gpu items-stretch !px-0 lg:ease-in-out;
  }

  .swiper-slide {
    @apply flex flex-col justify-end transition-all duration-300;
  }
}
</style>
